import React from 'react';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <a href="#" data-event="header_logo"><img src="logo.svg" alt="Find Balance Logo" /></a>
        </div>
        <nav>
          <ul>
            <li><a href="#features" data-event="nav_features">Características</a></li>
            <li><a href="#about" data-event="nav_about">Sobre Nosotros</a></li>
            <li><a href="#contact" data-event="nav_contact">Contacto</a></li>
            <li><a href="https://app.findbalance.es" className="nav-cta" data-event="nav_register">Registrarse</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
